import { useMediaQuery } from "@mui/material";

function useIsDesktop(){
    return useMediaQuery("(min-width: 769px)");
}

export{useIsDesktop}